export default __webpack_public_path__ + "static/media/no_result.a12cf664.png";